import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'

// User is identified by a bearer token (Authorization header)
export const ComputeTargetingTagsFitRequest = z.object({
  targetingTagsFloor: z.record(z.number()),
})

export type ComputeTargetingTagsFitRequest = z.infer<typeof ComputeTargetingTagsFitRequest>

export const ComputeTargetingTagsFitResponse = z.object({
  score: z.number(),
  qualifyingTagsScores: z
    .object({
      tag: z.string(),
      score: z.number(),
    })
    .array(),
})

export type ComputeTargetingTagsFitResponse = z.infer<typeof ComputeTargetingTagsFitResponse>

export const computeTargetingTagsFitDeclaration = endpointDeclaration(
  ComputeTargetingTagsFitRequest,
  ComputeTargetingTagsFitResponse,
)
